import { createContext } from 'react';
import { CheckoutStep } from '../../types/checkouts';
import {
  EMPTY_SELECTION,
  PickerSelection,
} from '../../utils/catalog/catalogFilters';

export const DEFAULT_CHECKOUT_FORM_STATE = {
  isDebouncing: false,
  isError: false,
  isFetching: false,
  query: '',
  step: 'items' as CheckoutStep,
  picker: { ...EMPTY_SELECTION, query: '' } as PickerSelection & {
    query: string;
  },
};

export type CheckoutFormState = typeof DEFAULT_CHECKOUT_FORM_STATE;

export type CheckoutFormStateAction =
  | { type: 'SET_DEBOUNCING'; payload: CheckoutFormState['isDebouncing'] }
  | { type: 'SET_ERROR'; payload: CheckoutFormState['isError'] }
  | { type: 'SET_QUERY'; payload: CheckoutFormState['query'] }
  | { type: 'SET_STEP'; payload: CheckoutFormState['step'] }
  | { type: 'SET_PICKER'; payload: Partial<CheckoutFormState['picker']> }
  | { type: 'RESET_PICKER' };

interface CheckoutFormContextType {
  state: CheckoutFormState;
  dispatch: React.Dispatch<CheckoutFormStateAction>; // Replace 'any' with the actual action type if you have one
}

const defaultContextValue: CheckoutFormContextType = {
  state: DEFAULT_CHECKOUT_FORM_STATE,
  dispatch: () => {},
};

export const CheckoutFormContext =
  createContext<CheckoutFormContextType>(defaultContextValue);
